module.exports = __webpack_public_path__ + "img/stalking-paa-snapchat-3.dc7fc8ce.png";